<template>
  <el-dialog
    append-to-body
    destroy-on-close
    class="page-dialog center-dialog"
    :visible="visible"
    :title="dialogTitle"
    width="80%"
    @close="$emit('update:visible', false)"
    @closed="$emit('closed')"
  >
    <div style="height: 540px">
      <SchemaTablePage
        ref="tablePageRef"
        layout-mode="dialog"
        :immediate="false"
        :search-schema="searchSchema"
        :columns="tableColumns"
        :table-attrs="tableAttrs"
        :default-query="defaultQuery"
        :request="request"
        :build-params="buildParams"
        :parse-result="parseResult"
      >
        <template #search-account="{ query }">
          <el-input
            v-model="query.accountValue"
            :placeholder="query.accountType === 'uid' ? '输入代理ID' : '输入代理账号'"
            :inputmode="query.accountType === 'uid' ? 'numeric' : 'text'"
            maxlength="20"
            clearable
            @input="onAccountInput(query, $event)"
          >
            <template #prepend>
              <el-select v-model="query.accountType" style="width: 100px" @change="onAccountTypeChange(query, $event)">
                <el-option label="代理账号" value="username"></el-option>
                <el-option label="代理ID" value="uid"></el-option>
              </el-select>
            </template>
          </el-input>
        </template>
        <template #username="{ row }">
          <div>
            {{ row.username }}
          </div>
          <span>
            {{ row.uid }}
          </span>
        </template>
        <template #agentBackGold="{ row }">
          {{ row.agent_back_gold | centsToYuan }}
        </template>
        <template #totalPayinAmount="{ row }">
          {{ row.total_payin_amount | centsToYuan }}
        </template>
        <template #totalBetAmount="{ row }">
          {{ row.total_bet_amount | centsToYuan }}
        </template>
        <template #shareOneGoldToInviter="{ row }">
          <span v-if="type === 'direct'">
            {{ row.share_one_gold_to_inviter | centsToYuan }}
          </span>
          <span v-if="type === 'indirect'">
            {{ row.share_two_gold_to_inviter | centsToYuan }}
          </span>
        </template>
        <template #createdAt="{ row }">
          {{ row.created_at | formatTime }}
        </template>
        <template #loginAt="{ row }">
          {{ row.login_at | formatTime }}
        </template>
      </SchemaTablePage>
    </div>
  </el-dialog>
</template>

<script>
import { AgentApi } from '@/api/agent'
import { parseTime } from '@/utils'
import { centsToYuan } from '@/utils/amount'
import SchemaTablePage from '@/components/SchemaTablePage/index.vue'

export default {
  name: 'AgentInviteUserListDialog',
  components: { SchemaTablePage },
  filters: {
    formatTime(value) {
      if (value == null) {
        return '--'
      }
      return parseTime(value)
    },
    centsToYuan,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    inviterUid: {
      type: Number,
      default: null,
    },
    username: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'direct', // direct: 直属代理, indirect: 二级代理
    },
  },
  data() {
    return {
      searchSchema: [
        {
          prop: 'account',
          label: '代理账号/ID',
          component: 'slot',
          slot: 'search-account',
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { type: 'index', label: '序号', width: 60, resizable: false },
        { prop: 'username', label: '代理账号', width: 140, resizable: false, slot: 'username' },
        // { prop: 'uid', label: '代理ID', width: 80, resizable: false },
        { prop: 'share_num', label: '直属下级人数', width: 100, resizable: false },
        { prop: 'agent_back_gold', label: '已获得佣金', width: 120, resizable: false, slot: 'agentBackGold' },
        { prop: 'total_payin_amount', label: '累计存款', width: 120, resizable: false, slot: 'totalPayinAmount' },
        { prop: 'total_bet_amount', label: '累计下注', width: 120, resizable: false, slot: 'totalBetAmount' },
        {
          prop: 'share_one_gold_to_inviter',
          label: '贡献佣金',
          width: 120,
          resizable: false,
          slot: 'shareOneGoldToInviter',
        },
        { prop: 'created_at', label: '注册时间', minWidth: 160, resizable: false, slot: 'createdAt' },
        { prop: 'login_at', label: '最后登录时间', minWidth: 160, resizable: false, slot: 'loginAt' },
      ],
      tableAttrs: {
        border: true,
        stripe: true,
        size: 'mini',
        fit: true,
        'highlight-current-row': true,
      },
    }
  },
  computed: {
    dialogTitle() {
      const typeText = this.type === 'indirect' ? '二级' : '直属'
      return `${typeText}代理人数 - ${this.username}`
    },
    request() {
      return params => AgentApi.getInviteUserList(params)
    },
    defaultQuery() {
      return {
        accountType: 'username',
        accountValue: '',
      }
    },
    buildParams() {
      return ({ query, page, limit }) => {
        const params = {
          page,
          page_size: limit,
        }

        // 根据 accountType 设置 uid 或 username
        if (query?.accountType === 'uid') {
          params.uid = query?.accountValue || void 0
        } else {
          params.username = query?.accountValue || void 0
        }

        if (this.type === 'indirect') {
          params.inviter_parent_uid = this.inviterUid || void 0
        } else {
          params.inviter_uid = this.inviterUid || void 0
        }

        return params
      }
    },
    parseResult() {
      return response => {
        if (response && response.code === 0 && response.data) {
          return {
            list: response.data.list || [],
            total: response.data.total || 0,
          }
        }
        return { list: [], total: 0 }
      }
    },
  },
  methods: {
    onAccountTypeChange(query, type) {
      if (type === 'uid') {
        //去掉非数字字符
        query.accountValue = query.accountValue.replace(/\D/g, '')
      }
    },
    onAccountInput(query, value) {
      if (query.accountType === 'uid') {
        query.accountValue = String(value ?? '').replace(/\D+/g, '')
      }
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => this.$refs.tablePageRef?.reset?.())
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.schema-table-page) {
  .pagination-container {
    margin-top: 24px;
    text-align: right;
  }
}
</style>
